import { userIdProp } from '../providers/mixpanel';

const mixpanelDefaults = {
    // properties applied to the user during an event but not to the event itself
    userProfileProps: {
        // fixed value properties
        valueProps: {
            // once property has been set it will not be updated if set again e.g. user id
            immutable: {},
            // property can change over time e.g. last login date
            mutable: {},
        },
        incrementalProps: {},
    },

    // eslint-disable-next-line max-len
    // common properties that apply to all events going forward, not just on the event they were set on
    // values are persisted in cookie or local storage for ~ 1 year by default
    // ref: https://developer.mixpanel.com/docs/javascript#super-properties-live-in-local-storage
    superProps: {
        valueProps: {
            immutable: {
                Platform: 'Web',
            },
            mutable: {},
        },
        incrementalProps: {},
    },
};

// must be deep cloned when used as a base for events to ensure each event has their own values
// regardless of how deep the object is as otherwise only references to those values will copied
// resulting in events sharing and overriding values
export const defaultProps = {
    // properties applied directly to event with no additional behaviours
    baseProps: {},
    // provider specific properties that account for specific features & behaviours
    providerProps: {
        ...mixpanelDefaults,
    },
};

export const setUserId = (userId, eventProps) => {
    // TODO: also set $user_id if id merge is enabled in the future,
    // see https://help.mixpanel.com/hc/en-us/articles/360039133851#changes-after-enabling-id-merge
    eventProps.providerProps.userProfileProps.valueProps.immutable[userIdProp] = userId;
};

/**
 * Set tracking option for tracked event to be sent to the provider as
 * it's called rather than batched / queued
 */
export const trackEventOnCallOption = {
    send_immediately: true,
};
